import React, { useState, useEffect } from "react";
import '@google/model-viewer';

const ModelCard = ({ modelSrc }) => {
  const [viewerStyle, setViewerStyle] = useState({
    width: '80%',
    height: '500px',
  });

  useEffect(() => {
    const updateStyle = () => {
      if (window.innerWidth <= 768) {
        setViewerStyle({ width: '90%', height: '400px', float: 'right'});
      } else if (window.innerWidth <= 1080) {
        setViewerStyle({ width: '100%', height: '450px' });
      } else {
        setViewerStyle({ width: '80%', height: '800px' });
      }
    };

    updateStyle();
    window.addEventListener('resize', updateStyle);

    return () => window.removeEventListener('resize', updateStyle);
  }, []);

  return (
    <div className="model-card">
      <div className="model-container">
        <model-viewer
          src={modelSrc}
          auto-rotate
          camera-controls
          disable-pan
          disable-zoom
          ar
          style={viewerStyle}
          camera-orbit="0deg 80deg auto"
          camera-boundary="0deg 45deg 50%"></model-viewer>
      </div>
    </div>
  );
};

export default ModelCard;
